import { Injectable } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading!: HTMLIonLoadingElement | null;
  private loadingState = new BehaviorSubject<boolean>(false);
  private loadingCounter = 0;

  constructor(
    private loadingController: LoadingController,
    private alertController: AlertController,
    private toastController: ToastController
  ) { }

  async presentLoading(message: string = 'Carregando...') {
    this.loadingCounter++;
    console.log('enter loadingCounter => ', this.loadingCounter);

    if (this.loadingState.value) {
      return;
    }

    try {
      this.loadingState.next(true);

      this.loading = await this.loadingController.create({
        message,
        mode: 'ios',
        backdropDismiss: false,
        duration: 10000
      });

      await this.loading.present();
    } catch (error) {
      console.error('Erro ao exibir loading:', error);
      this.loadingState.next(false);
      console.log('nullify loading counter');
      this.loading = null;
    }
  }

  isLoading(): boolean {
    return this.loadingState.value;
  }

  getLoadingState() {
    return this.loadingState.asObservable();
  }

  async dismissLoading() {
    if (this.loadingCounter > 0) {
      this.loadingCounter--;
    }
    console.log('leave loadingCounter => ', this.loadingCounter);

    if (this.loadingCounter > 0) {
      return;
    }

    this.loadingState.next(false);

    if (this.loading) {
      try {
        await this.loading.dismiss();
      } catch (error) {
        console.error('Erro ao fechar loading:', error);
      }
    }

    return;
  }

  async forceCleanLoading() {
    this.loadingCounter = 0;

    this.loadingState.next(false);

    if (this.loading) {
      try {
        await this.loading.dismiss();
      } catch (error) {
        console.error('Erro ao forçar fechamento do loading:', error);
      } finally {
        console.log('nullify loading counter');
        this.loading = null;
      }
    }
  }

  async presentAlertConfirm(
    header: string,
    subHeader: string,
    message: string,
    agreeFunction: () => void
  ) {
    const alert = await this.alertController.create({
      header,
      subHeader,
      message,
      mode: 'ios',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
        },
        {
          text: 'Sim',
          handler: () => agreeFunction(),
        },
      ],
    });

    return await alert.present();
  }

  async presentAlertConfirmOrCancel(
    header: string,
    subHeader: string,
    message: string,
    agreeFunction: () => void,
    cancelFunction: () => void
  ) {
    const alert = await this.alertController.create({
      header,
      subHeader,
      message,
      mode: 'ios',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => cancelFunction(),
        },
        {
          text: 'Sim',
          handler: () => agreeFunction(),
        },
      ],
    });

    return await alert.present();
  }

  async presentToast(message: string, color: string = 'medium') {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
      mode: 'ios',
      color: color,
    });
    toast.present();
  }

  async presentToastWithOptions() {
    const toast = await this.toastController.create({
      header: 'Toast header',
      message: 'Click to Close',
      mode: 'ios',
      position: 'top',
      buttons: [
        {
          side: 'start',
          icon: 'star',
          text: 'Favorite',
          handler: () => {
            console.log('Favorite clicked');
          },
        },
        {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  async createToast(message: string = 'Carregando...') {
    return this.loadingController.create({
      message,
      mode: 'ios',
    });
  }
}
